import { render, staticRenderFns } from "./StockArsip.vue?vue&type=template&id=8ca21278&"
import script from "./StockArsip.vue?vue&type=script&lang=js&"
export * from "./StockArsip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports